import { computed, defineComponent } from "vue";
import { validationRequired } from "@/core/helpers/validation";
export default defineComponent({
    props: {
        tableFields: {
            type: Array,
            default: () => {
                return [];
            }
        },
        disabled: Boolean,
        order: Number
    },
    emits: ['update:tableFields'],
    setup(props, { emit }) {
        const formValue = computed({
            get() {
                return props.tableFields;
            },
            set(value) {
                emit('update:tableFields', value);
            }
        });
        const rowMap = computed(() => {
            var _a;
            if (formValue.value.length === 0)
                return [];
            return Array.from({
                length: ((_a = formValue.value[0].datas) === null || _a === void 0 ? void 0 : _a.length) || 0
            }, (item, index) => {
                let datas = [];
                let types = [];
                formValue.value.forEach((item) => {
                    datas.push(item.datas[index]);
                    types.push(item.type);
                });
                return {
                    datas,
                    types
                };
            });
        });
        return {
            validationRequired,
            formValue,
            rowMap,
        };
    }
});
